<template>
  <div class="order-list-parts-des" v-if="showData">
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane
        :label="$lange == 'en' ? 'Details' : '配件详情'"
        name="description"
      >
        <div class="top"  v-if="partsListData.workOrder" >
          <div class="top-col flex-between">
            <p
              class="jump-url row-clip"
              @click="
                gotoPage('/admin/order/des?id='+ partsListData.workOrder.id,'服务请求详情')
              "
            >
              {{ $lange == "en" ? "Service Request" : "服务号" }}:
              {{ `${partsListData.workOrder.id}` }}
            </p>
            <p
              class="jump-url row-clip"
              @click="
                gotoPage(
                  '/admin/customer/description?customerId='+partsListData.workOrder.customerId,'客户详情'              
                )
              "
            >
              {{ $lange == "en" ? "Customer" : "客户" }}:
              {{ `${partsListData.workOrder.customer.customerName}` }}
            </p>
            <p
            
              class="jump-url"
              v-if="partsListData.workOrder.product"
              @click="
                gotoPage(
                  '/admin/project/description?fasId='+partsListData.workOrder.product.fasId,'项目详情'  
                )
              "
            >
              FAS: {{ partsListData.workOrder.product.fasId }}
            </p>
            <p>
              {{ $lange == "en" ? "Responsible" : "处理人" }}:
              {{ partsListData.workOrder.handlerName || "---" }}
            </p>
            <p>
              {{ $lange == "en" ? "Customer Manager" : "客户经理" }}:
              {{ partsListData.workOrder.customer.customerManager }}
            </p>
            <p></p>
          </div>
          <div class="top-col flex-between" v-if="partsListData.workOrder.product">
            <p>
              {{ $lange == "en" ? "Product Line" : "产品线" }}:
              {{ partsListData.workOrder.product.productLine }}
            </p>
            <p>
              {{ $lange == "en" ? "Speed" : "速度" }}:
              {{ partsListData.workOrder.product.speed }}
            </p>
            <p>
              {{ $lange == "en" ? "Width" : "幅宽" }}:
              {{ partsListData.workOrder.product.breadth }}
            </p>
            <p>
              {{ $lange == "en" ? "Stacker Layer" : "堆叠层数" }}:
              {{ partsListData.workOrder.product.stackedLayers }}
            </p>
            <p>
              {{ $lange == "en" ? "Flutes" : "瓦楞层数" }}:
              {{ partsListData.workOrder.product.corrugatedLayers }}
            </p>
            <p></p>
          </div>
          <div class="top-col flex-between">
            <p>
              {{ $lange == "en" ? "Contact" : "申请人" }}:
              {{ partsListData.workOrder.userName }}
            </p>
            <p>
              {{ $lange == "en" ? "Mobile" : "联系方式" }}:
              {{ partsListData.workOrder.phone }}
            </p>
            <p
            v-if="partsListData.workOrder.product"
              class="row-clip"
              style="max-width: 500px"
              :title="partsListData.workOrder.product.productAddress"
            >
              {{ $lange == "en" ? "Address" : "收货地址" }}:
              {{ partsListData.workOrder.product.productAddress }}
            </p>
            <p></p>
            <p></p>
            <p></p>
          </div>
        </div>
        <template v-if="partsListData.id">
          <OrderPartsList
            :partsListData="partsListData"
            @updateOrder="getPartsList"
            :isHandleV2="isHandle"
          ></OrderPartsList>

          <!---备料中 部分发货-->
          <template v-if="partsListData.status >= 4">
            <OrderPartseXpress
              :partsListData="partsListData"
              @updateOrder="getPartsList"
              :isHandleV2="isHandle"
            ></OrderPartseXpress>
          </template>

          <OrderPartsRemark
            :partsListData="partsListData"
            @updateOrder="updateOrder"
          ></OrderPartsRemark>
        </template>
      </el-tab-pane>
      <el-tab-pane
        :label="$lange == 'en' ? 'Status recording' : '处理记录'"
        name="Statusrecording"
      >
        <template v-if="activeName == 'Statusrecording'">
          <OrderPartseLog :partsOrderId="partsListData.id"></OrderPartseLog>
        </template>
      </el-tab-pane>
      <el-tab-pane
        :label="$lange == 'en' ? 'Attachment' : '附件库'"
        name="Attachment"
      >
        <template v-if="partsListData.id && activeName == 'Attachment'">
          <OrderPartseFile :partsOrderId="partsListData.id"></OrderPartseFile>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from "moment";
import OrderPartsList from "./components/OrderPartsList";
import OrderPartsRemark from "./components/OrderPartsRemark";
import OrderPartseXpress from "./components/OrderPartseXpress";
import OrderPartseFile from "./components/OrderPartseFile";
import OrderPartseLog from "./components/OrderPartseLog";

export default {
  name: "OrderPartsDescription",
  props: {
    partsListIdV2: String,
    isDialog: Boolean,
  },
  components: {
    OrderPartsList,
    OrderPartsRemark,
    OrderPartseXpress,
    OrderPartseFile,
    OrderPartseLog,
  },
  data() {
    return {
      uploaderConf2: this.$uploadUtils.config,
      partsListData: {},
      partsListId: "",
      isHandle: false,
      showData: false,
      activeName: "description",
    };
  },
  methods: {
    //获取配件订单
    getPartsList() {
      this.ccRequest
        .do("admin/fsb/parts/order/get", { id: this.partsListId }, "GET")
        .then((res) => {
          this.partsListData = res;
          this.isHandle = res.isHandle;
          this.showData = true;
        });
    },
    updateOrder(e) {
      this.ccRequest
        .do("admin/fsb/parts/order/get", { id: this.partsListId }, "GET")
        .then((res) => {
          // for (let index = 0; index < e.length; index++) {
          //   this.partsListData[e[index].code] = res[e[index]];
          // }
          this.partsListData = res;
        });
    },
    gotoPage(path, key, value) {
      // let query = {};
      // query[key] = value;
      // this.$router.push({
      //   path: path,
      //   query: query,
      // });
      this.newWindow({
        url:path,
        name:key
      })
    },
  },
  mounted() {
    if (!this.isDialog) {
      if (this.$route.query.id) {
        this.partsListId = this.$route.query.id;
      } else {
        this.$router.go(-1);
      }
    } else {
      this.partsListId = this.partsListIdV2;
    }

    this.getPartsList();
  },
};
</script>
<style>
.el-tabs__content {
  padding: 0 !important;
  background: #ffffff;
}
</style>
<style scoped lang="scss">
.order-list-parts-des {
  .top {
    padding: 20px;
    .top-col {
      max-width: 90%;
      &:not(:last-child) {
        margin-bottom: 20px;
      }
      justify-content: flex-start;
      > * {
        flex: 0 20%;
        &.jump-url {
          text-decoration: underline;
          cursor: pointer;
        }
        &.long-text {
          min-width: 350px;
          margin-right: 60px;
        }
      }
    }
  }
  .content {
    padding: 20px;
    border-top: 5px solid #f3f3f4;
    .table-title {
      justify-content: flex-start;

      > div {
        margin-left: 120px;
        span.select-box {
          margin: 0 15px;
        }
      }
    }
    .table-box {
      margin-top: 20px;
    }
  }
  .parts-card {
    padding: 20px;
    border-top: 5px solid #f3f3f4;
    .card-list {
      margin-bottom: 20px;
      height: 100%;
      &:not(:last-child) {
        padding-bottom: 40px;
        border-bottom: 1px solid #ccc;
      }
    }
    .card-right {
      justify-content: flex-end;
    }
    .card-title {
      height: 40px;
    }
    .card-box {
      margin-top: 15px;
      border: 1px solid #e4e4e4;
      padding: 20px;
      min-height: 200px;
      > div {
        display: flex;
        .left {
          flex: 1;

          & > .name {
            margin-top: 20px;
            display: flex;
            > .table-box {
              width: 245px;
              margin-left: 15px;
            }
          }
        }
        .right {
          margin-top: 20px;
          align-items: flex-start;
          > div {
            width: 200px;
            height: 100px;
          }
          .track-img {
            margin-left: 15px;
            position: relative;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
